'use strict';

require('../../style/index.less');

require('./index.less');

require('../../radio/style');

require('../../checkbox/style');

require('../../dropdown/style');

require('../../spin/style');

require('../../pagination/style');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/table/style/index.js
// module id = 16
// module chunks = 0